export default {
  setLoading (state, payload) {
    state.loading = payload
  },
  setError (state, payload) {
    console.error(payload)
    state.error = payload
  },
  clearError (state) {
    state.error = null
  },
  /**
   * Set User updates the properties passed in via
   * the payload, leaving unmodified properties in place
   */
  updateUser (state, payload) {
    state.user = {
      ...state.user,
      ...payload
    }
  },
  /**
   * Used for logging user out. Removing all local data
   */
  unsetUser (state, payload) {
    state.user = payload
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js